import * as React from 'react';
import styled from '@emotion/styled';
import { AbstractModel } from '../../core/stores/models/abstract/AbstractModelStore';
import { observer } from 'mobx-react';
import { EmptyWidget } from '../content/EmptyWidget';
import { Font } from '../../fonts';
import { useEffect } from 'react';

export interface AboutSectionWidgetProps {
  model: AbstractModel<{ about?: string }>;
}

export const AboutSectionWidget: React.FC<AboutSectionWidgetProps> = observer((props) => {
  useEffect(() => {
    props.model.refresh();
  }, [props.model]);
  const { model } = props;
  return (model.data.about || '').trim() === '' ? (
    <EmptyWidget label="No about yet!" />
  ) : (
    <S.About>{model.data?.about || ''}</S.About>
  );
});

namespace S {
  export const About = styled.pre`
    color: ${(p) => p.theme.text.primary};
    font-family: ${Font.Normal};
    white-space: pre-line;
    padding-top: 20px;
  `;
}
